import { Suspense } from 'react'
import { Await, useLoaderData } from 'react-router-dom'
import { TableSkeleton } from 'components/skeletons'
import { LocalApiError } from 'components/ui'
import { ModalProvider } from 'features/common'
import { useDrivers } from '../../hooks/useDrivers'
import { Driver } from '../../interfaces/driver'
import { DriversTable } from './DriversTable'
import { routePaths } from '../../../../routes'
import { driversService } from '../../index'

export const DriversLoader = () => {
  const { drivers } = useLoaderData() as { drivers: Driver[] }
  const { drivers: data } = useDrivers({ initialData: drivers })

  return (
    <Suspense fallback={<TableSkeleton />}>
      <Await resolve={drivers} errorElement={<LocalApiError message="failedToLoadDrivers" />}>
        <ModalProvider>
          <DriversTable
            path={routePaths.drivers}
            drivers={data}
            exportAction={driversService.driverTableExport}
          />
        </ModalProvider>
      </Await>
    </Suspense>
  )
}
